import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ApiService } from '../../shared/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private api: ApiService,
    private router: Router,
    public jwtHelperService: JwtHelperService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,

    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const accessToken = localStorage.getItem('access_token');
    const isLoggedIn = localStorage.getItem('authenticated');
    const ispending_otp_verification = localStorage.getItem('pending_otp');

    /* if (ispending_otp_verification && JSON.parse(ispending_otp_verification)) {
      this.router.navigateByUrl(`auth/otp`);
    } else {
      return true;
    }*/
    try {
      const expirationDate = this.jwtHelperService.getTokenExpirationDate();
      console.log('expiration : ', expirationDate);
      if (this.jwtHelperService.isTokenExpired(accessToken)) {
        this.router.navigate(['auth/login']);
        return false;
      }
    } catch {
      this.router.navigate(['auth/login']);
      return false;
    }

    if (isLoggedIn && JSON.parse(isLoggedIn)) {
      return true;
    } else {
      this.router.navigate(['auth/login']);
    }
  }
}
